// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1bah1h6o{justify-content:center}
._1e0c1txw{display:flex}
._1tke16li{min-height:var(--link-picker-min-height)}
._4cvr1fhb{align-items:stretch}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/link-picker/dist/esm/common/ui/min-height-container/index.compiled.css"],"names":[],"mappings":"AAAA,WAAW,sBAAsB;AACjC,WAAW,YAAY;AACvB,WAAW,wCAAwC;AACnD,WAAW,mBAAmB","sourcesContent":["._1bah1h6o{justify-content:center}\n._1e0c1txw{display:flex}\n._1tke16li{min-height:var(--link-picker-min-height)}\n._4cvr1fhb{align-items:stretch}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
